import Image from 'next/image'
import styles from './Loader.module.scss'

const Loader = () => {
  return (
    <div className={styles['loading-container']}>
      <Image alt='loader' src={'/assets/loader-100x100.gif'} width={75} height={75} unoptimized />
    </div>
  )
}

export default Loader
